import { useMutation, useQueryClient } from '@tanstack/react-query';
import unsubscribeSchool from '../../api/school-wishlist/unsubscribe-school';
import { world } from '../../languages';
import { baseSearchKeys } from '../base-search/query-keys/query-keys';
import qualityEvents from '../quality-events/quality-events';
import { schoolWishlistVotesKeys } from '../school-wishlist-votes/query-keys/query-keys';
import { wishlistKeys } from '../wishlist/query-keys/query-keys';
import { schoolWishlistKeys } from './query-keys/query-keys';
import { applyOptimisticSchoolWishlistChange, rollbackSchoolWishlistChange } from './school-wishlist-cache';

const useUnsubscribeSchool = (schoolId: number | null, searchRequestId?: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: unsubscribeSchool,
        onMutate: ({ materialId }) =>
            applyOptimisticSchoolWishlistChange(queryClient, materialId, {
                isInWishlist: false,
                suggestedByUserId: null
            }),
        onError: (_error, { materialId }, snapshot) => {
            if (snapshot) {
                rollbackSchoolWishlistChange(queryClient, materialId, snapshot);
            }

            queryClient.invalidateQueries({ queryKey: schoolWishlistKeys.membership(materialId) });
        },
        onSuccess: (_data, { materialId }) => {
            qualityEvents.schoolWishlist.removeFromSchoolWishlist({ schoolId, materialId, searchRequestId });
        },
        onSettled: (_data, _error, { materialId }) => {
            queryClient.invalidateQueries({ queryKey: schoolWishlistKeys.total() });
            // A school master's hearts read the personal wishlist, which mirrors the school one for them.
            queryClient.invalidateQueries({ queryKey: wishlistKeys.membership('user', world, materialId) });
            queryClient.invalidateQueries({ queryKey: schoolWishlistVotesKeys.voters(materialId) });
            queryClient.invalidateQueries({ queryKey: baseSearchKeys.all });
        }
    });
};

export default useUnsubscribeSchool;
